const contextTypes = {
    APP: 'In App',
    DISPLAY: 'Display',
    VIDEO: 'Video',
};

export default contextTypes;
